var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var dot = require("./lib/dot");
var showMore = null; 
var pymChild = null;
var $ = require("./lib/qsa");

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child;

    //add show more toggle
    showMore = $.one(".show-more");
    showMore.addEventListener('click', onToggleClicked);

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

var onToggleClicked = function() {
  var grid = $.one(".graphic");
  if (grid.classList.contains("show-all")) {
    grid.classList.remove("show-all");
    showMore.textContent = showMore.dataset.more;
    pymChild.scrollParentToChildEl("grid");
  } else {
    grid.classList.add("show-all");
    showMore.textContent = showMore.dataset.less;
  }
  if (pymChild) {
    pymChild.sendHeight();
  }
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);

